"use strict";
/* globals module */
/**
 * @module notificationsRegistrationsUsersRoute
 * @description Baasic Notifications Registrations Users Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Users Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var _1 = require("./");
var NotificationsRegistrationsUsersRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsUsersRoute, _super);
    function NotificationsRegistrationsUsersRoute(appOptions, notificationsRegistrationsUsersBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsRegistrationsUsersBatchRoute = notificationsRegistrationsUsersBatchRoute;
        _this.createRoute = 'notifications/registrations/user';
        _this.findRoute = 'notifications/registrations/user/{?searchQuery,userIds,providers,page,rpp,sort,embed,fields}';
        _this.getRoute = 'notifications/registrations/user/{id}/{?embed}';
        _this.deleteRoute = 'notifications/registrations/user/{id}';
        _this.updateRoute = 'notifications/registrations/user/{id}';
        return _this;
    }
    Object.defineProperty(NotificationsRegistrationsUsersRoute.prototype, "batch", {
        get: function () {
            return this.notificationsRegistrationsUsersBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses create users registrations route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersRoute.create();
     */
    NotificationsRegistrationsUsersRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses find users registrations route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user subscription properties using the phrase search.
     * - `userIds` - Comma separated list of user identifiers.
     * - `providers` - Comma separated list of notification providers.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subscription subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user subscription property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example notificationsRegistrationsUsersRoute.find({ searchQuery: '<search-phrase>', providers: '<provider-name>,<provider-name>' });
     */
    NotificationsRegistrationsUsersRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get users registrations route; this route should be expanded with the Id of users registrations resource.
     * @method
     * @param id The registration identifier which uniquely identifies UserRegistration resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsRegistrationsUsersRoute.get({ id: '<registration-id>' });
     */
    NotificationsRegistrationsUsersRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses delete users registrations route; this route should be expanded with the Id of users registrations resource.
     * @method
     * @param data An object used to delete specified UserRegistration resource.
     * @example notificationsRegistrationsUsersRoute.delete(data);
     */
    NotificationsRegistrationsUsersRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses update users registrations route; this route should be expanded with the Id of users registrations resource.
     * @method
     * @param data An object used to update specified UserRegistration resource.
     * @example notificationsRegistrationsUsersRoute.update(data);
     */
    NotificationsRegistrationsUsersRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b;
    NotificationsRegistrationsUsersRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsUsersBatchRoute !== "undefined" && _1.NotificationsRegistrationsUsersBatchRoute) === "function" ? _b : Object])
    ], NotificationsRegistrationsUsersRoute);
    return NotificationsRegistrationsUsersRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsUsersRoute = NotificationsRegistrationsUsersRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
